import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './Nixgon.scss';

class Nixgon extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/nixgon/detail">
          <div className="dashed-wrap nixgon">
            <h4 className="content-title">
              <span className="font-company">Nixgon, 네오폰트</span>
              <span className="font-title">닉스곤체 / Nixgon Fonts</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default Nixgon;